import React from 'react';
import { Helmet } from 'react-helmet';

import '../scss/Elements/_tables.scss';
import { AssetLogsTableAxios } from '../components/Tables/AssetsLogsTable';

function AssetsLogs() {
  return (
    <div className='table-module-container'>
      <Helmet>
        <title>Logs de equipos</title>
      </Helmet>
      <div className='datatable'>
        <AssetLogsTableAxios />
      </div>
    </div>
  );
}

export default AssetsLogs;
